import { GroupActionsFn, PressureLevels, TemperatureLevels } from "../../../../../rest/GroupAction";
import { Timezone } from "../../../../../rest/Misc";
import { EntityType } from "../../../../../models";
import { ListActions } from "../../../../flux/Grid";
import { ErrorActions } from "../../../../flux/Error";
import { FlagActions } from "../../../../flux/Flag";
import { appNavigator } from "../../../../routes";
import { VehicleBatchEditActions, VehicleBatchEditStoreState, BatchAction, ActionType } from "../BatchEdit/flux";

export class ApplyVehicleGroupActionsCommand
{
    private readonly listActions = new ListActions();
    private readonly errorActions = new ErrorActions();
    private readonly inProgressActions = new FlagActions();
    private readonly vehicleBatchEditActions = new VehicleBatchEditActions();
    
    constructor(private getState: () => VehicleBatchEditStoreState, private groupActions: GroupActionsFn,
        private errorStoreToken: string, private inProgressToken: string)
    {
    }
    
    execute = () => {
        let { addedActions, ids } = this.getState();

        if(!addedActions || addedActions.length === 0)
            throw new Error('no group actions to apply');

        if(!ids || ids.length === 0){
            ids = JSON.parse(localStorage.getItem('groupActionVehicleIds'));
            // throw new Error('no ids selected to apply group actions');
        }

        this.inProgressActions.set(this.inProgressToken)
        this.groupActions({
            Vehicle: {
                Ids: ids,
                Actions: addedActions.map(extractActionPayload)
            }
        })
        .then(res => {
            if(!res.Success){
                throw new Error(res.ErrorMessage);
            }

            this.listActions.replaceItems(res.Entries.Vehicle, EntityType.Vehicle);
            appNavigator.goToVehicleTab();
            this.vehicleBatchEditActions.rejectDraft();
        })
        .catch(err => this.errorActions.setError(err, this.errorStoreToken))
        .then(() => this.inProgressActions.reset(this.inProgressToken)); // finaly
    }
}

export function extractActionPayload(batchAction: BatchAction<ActionType>)
{
    switch(batchAction.type) {
        case ActionType.AddTags:
            return { ApplyTags: batchAction.value as string[] };

        case ActionType.RemoveTags:
            return { RemoveTags: batchAction.value as string[] };
        
        case ActionType.SetTimezone:
            return { MoveToTimezone: (batchAction.value as Timezone).Id };

        case ActionType.SetPressure:
            return { SetPressureLevels: (batchAction.value as PressureLevels) };

        case ActionType.SetTemperature:
            return { SetTemperatureLevels: (batchAction.value as TemperatureLevels) };

        default:
            throw new Error(`unexpected ActionType: batchAction.type`);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Vehicle/commands/ApplyVehicleGroupActionsCommand.ts